import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { useBoolean } from "@vega-core/hooks/useBoolean";
import { m } from "@vega-core/paraglide/messages";

import { SnapshotFormModal } from "./SnapshotFormModal";

export function QuarterlyDataSection({ dealId }: { dealId: string }) {
  const { value: isOpen, setTrue: open, setFalse: close } = useBoolean(false);

  return (
    <>
      <div className="border border-border/primary rounded-lg card-paddings-default flex items-start justify-between gap-2">
        <div>
          <h2 className="heading-5">
            {m.coInvestments_report_quarterlyData_title()}
          </h2>
          <p className="body-small-regular text-text/secondary">
            {m.coInvestments_report_quarterlyData_subtitle()}
          </p>
        </div>
        <ThemedButton
          dataTestId="add-snapshot-button"
          onClick={open}
          size="small"
          type="button"
          variant="secondary"
        >
          {m.coInvestments_report_addEntry()}
        </ThemedButton>
      </div>

      {isOpen ? <SnapshotFormModal dealId={dealId} onClose={close} /> : null}
    </>
  );
}
